<div class="alert-wrapper">
  @for (dataPayload of alertList; track dataPayload) {
    <div
      class="alert"
    [ngClass]="{
      'alert-success': dataPayload?.alertType === 'success',
      'alert-error': dataPayload?.alertType === 'danger',
      'alert-warning': dataPayload?.alertType === 'warning'
    }"
      >
      <em
        class="alert-icon"
      [ngClass]="{
        'bi-check-circle': dataPayload?.alertType === 'success',
        'bi-x-circle': dataPayload?.alertType === 'danger',
        'bi-exclamation-circle': dataPayload?.alertType === 'warning'
      }"
        >
      </em>
      <div class="alert-details">
        <p class="alert-sub-title mb-0">{{ dataPayload?.subTitle }}</p>
      </div>
      <button
        type="button"
        class="alert-cancel"
        aria-label="Close"
        (click)="closeAlert(dataPayload)"
      >
        <em class="bi bi-x-lg" aria-hidden="true"></em>
      </button>
    </div>
  }
</div>
